import * as CTE                   from './01_core_types'


class debug
{
  static _debug_level: CTE.DEBUG = CTE.DEBUG.NO ;


  static set_debug_level ( level: CTE.DEBUG )
  {
    this._debug_level = level ;
  }


  static msg ( level: CTE.DEBUG, ...args: any[] )
  {
    if ( this._debug_level >= level )
      {
         const fn = level === CTE.DEBUG.WARNING? 'warn'
                  : level >= CTE.DEBUG.ERROR  ? 'error'
                  : 'log' ;

         console[ fn ]( ...args ) ;
      }
  }
}


export default debug ;
